import { Link, Outlet, createFileRoute, redirect } from '@tanstack/react-router'
import { WalletIcon } from 'lucide-react'
import type { CurrentUserResponse } from '@/tygo/dto'

export const Route = createFileRoute('/account')({
  beforeLoad: ({ context, location }) => {
    const user = context.queryClient.getQueryData<CurrentUserResponse>(['user'])
    if (!user) {
      throw redirect({
        to: '/login',
        search: {
          redirect: location.href,
        },
      })
    }
  },
  component: AccountLayout,
})

function AccountLayout() {
  return (
    <div className="flex flex-col lg:flex-row lg:items-start lg:justify-center lg:py-20">
      <div className="lg:w-64">
        <Link
          to="/account/wallet"
          className="flex items-center gap-2 hover:bg-secondary/90 p-2 px-4 rounded-sm"
        >
          <WalletIcon className="size-4" />
          Wallet
        </Link>
      </div>
      <div className="lg:w-[775px]">
        <Outlet />
      </div>
    </div>
  )
}
